import { render, staticRenderFns } from "./KeduAddCampaign.vue?vue&type=template&id=bf962da4&scoped=true&"
import script from "./KeduAddCampaign.vue?vue&type=script&lang=js&"
export * from "./KeduAddCampaign.vue?vue&type=script&lang=js&"
import style0 from "./KeduAddCampaign.vue?vue&type=style&index=0&id=bf962da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf962da4",
  null
  
)

export default component.exports